module.exports = __webpack_public_path__ + "img/poya.5a66e5a1.svg";